import React, { useEffect, useRef, useState } from 'react';
import AccordionItem from "./AccordionItem";
import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const accordionOptions = [
	{
		title: 'Testnet',
		value: 'For those who prefer not to spend money on project activities and enjoy exploring technologies during the Testnet phase. We select the best projects that offer rewards for those participating in their testnets.'
	},
	{
		title: 'Mainnet without a Token',
		value: 'These are reviews of projects that have moved to the mainnet after the Testnet phase, where participation may require financial investment. We also provide information on the costs needed for activities in specific projects. Projects without a token can reward their participants with airdrops during the TGE.'
	},
];

const UniqueReviewsComponent = (/* props: IPlatformProjectProps */) => {
	const containerRef = useRef<HTMLDivElement | null>(null);
	const imagesRef = useRef<HTMLImageElement[]>([]);
	const textRef = useRef<HTMLDivElement[]>([]);
	const [activeIndex, setActiveIndex] = useState<number | null>(null);
	const [width, setWidth] = useState(window.innerWidth);
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => {
			window.removeEventListener("resize", updateDimensions);
		}
	}, []);
	
	const handleItemClick = (index: number) => {
		setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
	};
	
	const addToRefs = <T,>(refArray: React.MutableRefObject<T[]>, el: T | null) => {
		if (el && !refArray.current.includes(el)) {
			refArray.current.push(el);
		}
	};
	
	/* useLayoutEffect(() => {
		const animationSettings = {
			opacity: 0,
			duration: width < 425 ? 1.2 : 1.5,
			ease: 'power2.out',
		};
		
		if (!containerRef.current) return;
		
		imagesRef.current.forEach((image, index) => {
			if (image) {
				gsap.fromTo(
					image,
					{ ...animationSettings, x: width < 425 ? 0 : 50, y: width < 425 ? 80 : 0 },
					{
						opacity: 1,
						x: 0,
						y: 0,
						ease: 'power2.out',
						duration: 1,
						//delay: index * 0.2,
						scrollTrigger: {
							trigger: image,
							start: width < 425 ? 'top 75%' : 'top 65%',
							end: width < 425 ? 'top 65%' : 'top 55%',
							toggleActions: 'play none none reverse',
						},
					}
				);
			}
		});
		
		textRef.current.forEach((text, index) => {
			if (text) {
				gsap.fromTo(
					text,
					{ ...animationSettings, x: 0, y: width && width < 425 ? 80 : 100 },
					{
						opacity: 1,
						x: 0,
						y: 0,
						ease: 'power2.out',
						duration: 1,
						//delay: index * 0.2,
						scrollTrigger: {
							trigger: text,
							start: width && width < 425 ? 'top 75%' : 'top 65%',
							end: width && width < 425 ? 'top 65%' : 'top 55%',
							toggleActions: 'play none none reverse',
						},
					}
				);
			}
		});
	}, [containerRef]); */
	
	return (
		<div className="uniqueReviewsComponent projectsPanel" ref={containerRef} id="testComp__content_data_item_id_0">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			<div className="uniqueReviewsComponent__content">
				<div className="uniqueReviewsComponent__content_data"
				     id="heading1"
				>
					<div className="uniqueReviewsComponent__content_data_background"></div>
					<div
						className="uniqueReviewsComponent__content_data_item"
						ref={(el) => addToRefs(textRef, el)}
					>
						<h2>Only unique reviews of the best crypto projects</h2>
						{
							width < 1024 ? (
								<img
									src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/uniqueReviews/HyperlaneImage.webp`}
									alt="Hyperlane"
									ref={(el) => addToRefs(imagesRef, el)}
								/>
							) : null
						}
						<span>
              Our platform features up-to-date reviews of over 100 different projects.
							We categorize projects into two types: Testnet and Mainnet without a Token.
							Our guides will make it easy for you to navigate each direction.
            </span>
					</div>
					<div
						className="uniqueReviewsComponent__content_data_accordion"
						ref={(el) => addToRefs(textRef, el)}
					>
						{accordionOptions.map((item, index) => (
							<AccordionItem
								key={index}
								title={item.title}
								value={item.value}
								isOpen={activeIndex === index}
								onClick={() => handleItemClick(index)}
							/>
						))}
					</div>
				</div>
				{
					width > 1023 ? (
						<div className="uniqueReviewsComponent__content_images" id="img1">
							<div className="uniqueReviewsComponent__content_images_hyperlane">
								<img
									src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/uniqueReviews/HyperlaneImage.webp`}
									alt="Hyperlane"
									ref={(el) => addToRefs(imagesRef, el)}
								/>
							</div>
							<div className="uniqueReviewsComponent__content_images_xterio">
								<img
									src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/uniqueReviews/XterioImage.webp`}
									alt="Xterio"
									ref={(el) => addToRefs(imagesRef, el)}
								/>
							</div>
							<div className="uniqueReviewsComponent__content_images_reya">
								<img
									src={`${process.env.PUBLIC_URL}/assets/images/nfdPlatform/uniqueReviews/ReyaImage.webp`}
									alt="Reya"
									ref={(el) => addToRefs(imagesRef, el)}
								/>
							</div>
							<div
								className="uniqueReviewsComponent__content_images_background"
								ref={(el) => addToRefs(imagesRef, el as HTMLImageElement)}
							></div>
						</div>
					) : null
				}
			</div>
		</div>
	);
};

export default UniqueReviewsComponent;